'use client';

import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import styles from './LoadingOverlay.module.css';
import type { LoadingOverlayProps } from './LoadingOverlay.types';

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading, fullPage = false, className }) => {
  if (!isLoading) return null;

  return (
    <div
      className={`${styles.overlay} ${fullPage ? styles.fullPage : ''} ${className || ''}`}
      aria-live="polite"
      aria-label="Loading"
      data-testid="loading-overlay"
    >
      <div className={styles.loadingContainer}>
        <DotLottieReact
          src="/animations/loader.lottie"
          loop
          autoplay
          className={styles.loadingAnimation}
          width={200}
          height={200}
          aria-hidden="true"
        />
      </div>
    </div>
  );
};
